import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ClinicProductService } from 'src/app/_services/clinic-product.service';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-create-clinic-product',
  templateUrl: './create-clinic-product.component.html',
  styleUrls: ['./create-clinic-product.component.scss'],
})
export class CreateClinicProductComponent implements OnInit {
  selectedFile: File | null = null;
  isSubmitting: boolean = false;
  
  productForm: FormGroup = this.formBuilder.group({
    stock_item_code: ['', [Validators.required, Validators.minLength(3)]],
    size: ['', [Validators.required, Validators.minLength(1)]],
    description: ['', [Validators.required, Validators.minLength(5)]],
    quantity: [0, [Validators.required, Validators.min(1)]],
    cost_excl_vat: [0, [Validators.required, Validators.min(0.01)]],
    cost_incl_vat: [0, [Validators.required, Validators.min(0.01)]],
    product_id: ['', [Validators.required, Validators.minLength(3)]],
    is_active: [true, [Validators.required]],
  });

  constructor(
    private formBuilder: FormBuilder,
    private clinicProductService: ClinicProductService,
    public ref: DynamicDialogRef
  ) {}

  ngOnInit(): void {}

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.selectedFile = input.files[0];
    }
  }

  onSubmit() {
    if (this.productForm.invalid) return;
  
    this.isSubmitting = true;
    const formData = new FormData();
    const product = this.productForm.value;
  
    // Append form fields
    for (const key in product) {
      if (product.hasOwnProperty(key)) {
        const value = product[key];
        formData.append(key, value);
      }
    }
  
    // Append the file if selected
    if (this.selectedFile) {
      formData.append('image', this.selectedFile, this.selectedFile.name);
    }
  
    // Call your API
    this.clinicProductService.createClinicProduct(formData).subscribe({
      next: (res) => {
        console.log('Product created:', res);
        this.productForm.reset({ is_active: true });
        this.selectedFile = null;
        this.isSubmitting = false;
        this.ref.close(res); // Close dialog and pass back the new product
      },
      error: (err) => {
        console.error('Error creating product:', err);
        this.isSubmitting = false;
        // Show error message
      }
    });
  }
}
